/* eslint-disable import/prefer-default-export */
import { SET_CACHED_SYSTEM_TEXT_SIZE, LS_SYSTEM_TEXT_SIZE } from 'constants/index';

export function setCachedSystemTextSize(payload) {
  localStorage.setItem(LS_SYSTEM_TEXT_SIZE, payload);
  return dispatch => {
    dispatch({ type: SET_CACHED_SYSTEM_TEXT_SIZE, payload });
  };
}
